import React, { useEffect, lazy, Suspense } from 'react';
import { Switch, Route } from 'react-router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { currentUser } from './functions/auth';
import { auth } from './firebase';
import { useDispatch } from 'react-redux';
import { motion } from "framer-motion";
import CookieConsent from "react-cookie-consent";
import './Loading.css';
import { useHistory } from "react-router-dom";
import Popup from './Popup';
import {Helmet} from "react-helmet";
const Home = lazy(() => import('./pages/home/Home'));

const Editoffers = lazy(() => import('./components/home/EditOffers'));
const Offers = lazy(() => import('./pages/admin/offers/Offers'));
const sabCalculateretrive = lazy(() => import('./pages/admin/subestimate/sabCalculateretrive'));

const Login = lazy(() => import('./pages/auth/Login/Login'));
const Register = lazy(() => import('./pages/auth/Register'));
const Contact = lazy(() => import('./pages/contact/Contact'));
const Footer = lazy(() => import('./components/footer/Footer'));
const Header = lazy(() => import('./components/nav/Header'));
const SideDrawer = lazy(() => import('./components/drawer/SideDrawer'));
const RegisterComplete = lazy(() => import('./pages/auth/RegisterComplete'));
const ForgotPassword = lazy(() => import('./pages/auth/ForgotPassword'));
const History = lazy(() => import('./pages/user/History'));
const ServiceHistory = lazy(() => import('./pages/user/ServiceHistory'));
const Password = lazy(() => import('./pages/user/Password'));
const UserRoute = lazy(() => import('./components/routes/UserRoute'));
const WishList = lazy(() => import('./pages/user/Wishlist'));
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard'));
const AdminRoute = lazy(() => import('./components/routes/AdminRoute'));
const CategoryCreate = lazy(() => import('./pages/admin/category/CategoryCreate'));
const CategoryUpdate = lazy(() => import('./pages/admin/category/CategoryUpdate'));
const SubCreate = lazy(() => import('./pages/admin/sub/SubCreate'));
const SubUpdate = lazy(() => import('./pages/admin/sub/SubUpdate'));
const ServiceCreate = lazy(() => import('./pages/admin/service/ServiceCreate'));
const Services = lazy(() => import('./pages/admin/service/Services'));
const ServiceUpdate = lazy(() => import('./pages/admin/service/ServiceUpdate'));
const ServiceDetails = lazy(() => import('./pages/ServiceDetails'));
const Subestimate = lazy(() => import('./pages/admin/subestimate/SubEstimateCreate'));
const SubEstimateUpdate = lazy(() => import('./pages/admin/subestimate/SubEstimateUpdate'));
const CategoryHome = lazy(() => import('./pages/category/CategoryHome'));
const SubHome = lazy(() => import('./pages/sub/SubHome'));
const AllServices = lazy(() => import('./pages/AllServices'));
const SubCalculate = lazy(() => import('./pages/admin/subestimate/SubCalculate'));
const ScrollButton = lazy(() => import('./components/scroll/Scrollbutton'));
const Cart = lazy(() => import('./pages/Cart'));
const About = lazy(() => import('./components/about/About'));
const Checkout = lazy(() => import('./pages/Checkout'));
const CreateCouponPage = lazy(() => import('./pages/admin/coupon/CreateCouponPage'));
// const Payment = lazy(() => import('./pages/payment/Payment'));
const Testimonial = lazy(() => import('./pages/home/testimonial/Testimonial'));
const ReadTestimonail = lazy(() => import('./pages/home/testimonial/Readtestimonail'));
const FeedbackRetrive = lazy(() => import('./components/feedback-retrive/FeedbackRetrive'));
const UserRetrive = lazy(() => import('./components/users/UserRetrive'));
const Contactusretrive = lazy(() => import('./components/contactus-retrive/ContactusRetrive'));


const App = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        const idTokenResult = await user.getIdTokenResult()
        currentUser(idTokenResult.token)
          .then((res) => {
            dispatch({
              type: "LOGGED_IN_USER",
              payload: {
                name: res.data.name,
                email: res.data.email,
                token: idTokenResult.token,
                role: res.data.role,
                _id: res.data._id,
              },
            });
          })
          .catch();
      }
    });
    return () => unsubscribe();
  }, [dispatch]);
  const history = useHistory();
  return (
    <motion.div initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}>
         <Helmet>
                <meta charSet="utf-8" />
                <title>Omkar Cool Services| Home</title>
                <link rel="canonical" href="omkarcoolservices.com" />
                <meta name="description" content="Best Home Appliances Repair & Service Provider in Kalyan, Dombivli, Ulhasnagar, Ambernath, Badlapur | Authorised Symphony Service Partner in Kalyan Dombivli" />
                <meta name="keywords" content="Symphony service center in dombivali, Symphony aurthorised service center in kalyan, AC services near me, AC reapir and service near me, AC repair in Dombivli, AC Service in Dombivli, AC repair in Kalyan, AC Service in Kalyan, Fridge Repairing near me, fridge repairing in kalyan, fridge repair in dombivli, fridge repair in kalyan, Freezer repair near me, HVAC repair near me, Washing Machine Repair near me, Washing Machine Repair in kalyan, Washing Machine Repair in kalyan, Washing Machine Repair in dombivli, TV Repair near me, TV repair in Kalyan, TV repair in Dombivli, TV repair in Dombivli, Authorised Symphony Service center, Authorised symphony cooler repair near me, Microwave Repairing near me, Microwave repairing in kalyan, Microwave repair in dombivli, Microwave repair in kalyan, oven Repairing near me, oven repairing in kalyan, oven repair in dombivli, oven repair in kalyan, Ac installation in Kalyan, Ac installation near me, Ac installation in dombivali, Ac uninstalltion near  me, Ac unistallation in Kalyan, Ac uninstalltion in dombivali."></meta>
        </Helmet>
      <Suspense fallback={
        <div className="load">
          <h1>
            Loading
            <div class="dots">
              <span class="dot z"></span>
              <span class="dot f"></span>
              <span class="dot s"></span>
              <span class="dot t">
                <span class="dot l"></span>
              </span>
            </div>
          </h1>
        </div>
      }>
        <Header />
        <Popup/>
        <SideDrawer />
        <ToastContainer />

        <CookieConsent enableDeclineButton flipButtons
          debug={true}

          location="bottom"
          style={{ fontSize: "16px" }}
          buttonText="Get Estimation"
          onAccept={() => { history.push("/estimate-calculate") }}
          buttonStyle={{ fontSize: "16px", backgroundColor: "#cadc13" }}
          declineButtonText="Cancel"


          declineButtonStyle={{ fontSize: "16px", background: "#FF4D4D", color: "black", paddingLeft: "20px", paddingRight: "20px" }}
        >
          Get an Estimate of our services.
        </CookieConsent>

        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/about" component={About} />
          <Route exact path="/estimate-calculate" component={SubCalculate} />

          <Route exact path="/register" component={Register} />
          <Route exact path="/testimonial" component={Testimonial} />
          <Route exact path="/contact" component={Contact} />
          <Route exact path="/register/complete" component={RegisterComplete} />
          <Route exact path="/forgot/password" component={ForgotPassword} />
          <UserRoute exact path='/user/history' component={History} />
          <UserRoute exact path='/user/password' component={Password} />
          <UserRoute exact path='/user/wishlist' component={WishList} />
          <AdminRoute exact path='/admin/dashboard' component={AdminDashboard} />
          <AdminRoute exact path='/admin/category' component={CategoryCreate} />
          <AdminRoute exact path='/admin/category/:slug' component={CategoryUpdate} />
          <AdminRoute exact path='/admin/sub' component={SubCreate} />
          <AdminRoute exact path='/admin/sub/:slug' component={SubUpdate} />
          <AdminRoute exact path='/admin/subestimate/:slug' component={SubEstimateUpdate} />
          <AdminRoute exact path='/admin/service' component={ServiceCreate} />
          <AdminRoute exact path='/admin/offers' component={Offers} />
          <AdminRoute exact path='/admin/updateOffers/:slug' component={Editoffers} />
          <AdminRoute exact path='/admin/services' component={Services} />
          <AdminRoute exact path='/admin/retrivesubcalculate' component={sabCalculateretrive} />

          <AdminRoute exact path='/admin/subestimate' component={Subestimate} />
          <AdminRoute exact path='/admin/contactusretrive' component={Contactusretrive} />
          <AdminRoute exact path='/admin/useretrive' component={UserRetrive} />
          <AdminRoute exact path='/admin/feedback' component={FeedbackRetrive} />
          <AdminRoute exact path='/admin/service/:slug' component={ServiceUpdate} />
          <AdminRoute exact path='/admin/coupons' component={CreateCouponPage} />
          <AdminRoute exact path='/admin/testimonial' component={ReadTestimonail} />
          <Route exact path="/service/:slug" component={ServiceDetails} />
          <Route exact path="/category/:slug" component={CategoryHome} />
          <Route exact path="/sub/:slug" component={SubHome} />
          <Route exact path="/allservices" component={AllServices} />
          <Route exact path="/cart" component={Cart} />
          <UserRoute exact path='/checkout' component={Checkout} />
          <UserRoute exact path='/user/servicehistory' component={ServiceHistory} />
          {/* <UserRoute exact path='/payment' component={Payment} /> */}

        </Switch>

        <ScrollButton />
        <Footer />
      </Suspense>
    </motion.div>
  );
}

export default App;

